/** Изометрическая проекция: сетка ↔ экран. Один тайл — ромб 64×32. */

export const TILE_W = 64;
export const TILE_H = 32;

export interface ScreenPoint {
  x: number;
  y: number;
}

/** Верхняя вершина ромба клетки (gx, gy). */
export function gridToScreen(gx: number, gy: number): ScreenPoint {
  return {
    x: (gx - gy) * (TILE_W / 2),
    y: (gx + gy) * (TILE_H / 2),
  };
}

/** Центр клетки — туда ставим персонажа и объекты. */
export function gridToCenter(gx: number, gy: number): ScreenPoint {
  const p = gridToScreen(gx, gy);
  return { x: p.x, y: p.y + TILE_H / 2 };
}

/** Обратное преобразование: куда игрок ткнул мышкой. */
export function screenToGrid(sx: number, sy: number): { x: number; y: number } {
  const a = sx / (TILE_W / 2);
  const b = sy / (TILE_H / 2);
  return { x: (a + b) / 2, y: (b - a) / 2 };
}

/** Точки ромба клетки относительно её верхней вершины. */
export const TILE_DIAMOND: number[] = [
  0, 0,
  TILE_W / 2, TILE_H / 2,
  0, TILE_H,
  -TILE_W / 2, TILE_H / 2,
];

/** Глубина: чем дальше вправо-вниз по сетке, тем позже рисуем. */
export function depth(gx: number, gy: number): number {
  return (gx + gy) * 16;
}
